var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-order" },
    [
      _c(
        "el-table",
        {
          attrs: {
            fit: "",
            height: "496",
            data: _vm.list,
            "header-cell-class-name": "table-header-cell",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "60",
              align: "center",
              type: "index",
              "class-name": "table-header-cell",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.$index +
                            1 +
                            (_vm.queryParams.page - 1) * _vm.queryParams.limit
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "用户昵称", prop: "nickName", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(_vm._s(_vm._f("filterMemberName")(row.nickName))),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "手机号", prop: "mobile", "min-width": "120" },
          }),
          _c("el-table-column", {
            attrs: { label: "分享码", prop: "shareCode", "min-width": "80" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "身份等级",
              prop: "gradeName",
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "消费等级",
              prop: "consumerName",
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "合伙人身份", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("filterPartnership")(row.partnership))
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "注册时间",
              prop: "createTime",
              "min-width": "150",
            },
          }),
        ],
        1
      ),
      _c("pagination", {
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.limit,
          layout: "total, sizes, prev, pager, next",
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "limit", $event)
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }